import React from "react";
import { func, string, bool, arrayOf } from "prop-types";
import styled from "styled-components";
import { AnimatePresence, motion } from "framer-motion";

import MapFilterItem from "./MapFilterItem";

import { color, desktop } from "../shared/utils";
import gtm from "@gtm/core";
import { filterMapTypeEvent } from "@gtm/events/testdrive";
import { testDriveType } from "@types";

const Container = styled.div`
  position: relative;
  height: 0px;

  ${desktop`
    grid-row: 2;
    grid-column: 1;

  `}
`;

const StyledList = styled.ul`
  display: flex;
  justify-content: space-around;
  background: ${color("white")};
`;

const MapFilter = ({ filter, setFilter, isFilterOpen, testDriveTypes }) => {
  const getFilterEvent = (key, label) => () => {
    if (filter === key) {
      setFilter(null);
      return;
    }

    gtm.fire(filterMapTypeEvent(label));
    setFilter(key);
  };

  return (
    <Container>
      <AnimatePresence>
        {isFilterOpen && (
          <motion.div
            variants={{
              open: { opacity: 1, y: "-100%" },
              closed: { opacity: 0 },
            }}
            animate="open"
            initial="closed"
            exit="closed"
          >
            <StyledList>
              {testDriveTypes
                ?.filter(testDriveType => testDriveType.status)
                .map(({ id, label, colorHexa }) => (
                  <MapFilterItem
                    data-id={`test-drive-map-filter-item-${id}`}
                    isSelected={!filter || id === filter}
                    key={id}
                    type={id}
                    color={colorHexa}
                    title={label}
                    filterEvent={getFilterEvent(id, label)}
                  />
                ))}
            </StyledList>
          </motion.div>
        )}
      </AnimatePresence>
    </Container>
  );
};

MapFilter.propTypes = {
  filter: string,
  setFilter: func.isRequired,
  isFilterOpen: bool.isRequired,
  testDriveTypes: arrayOf(testDriveType),
};

export default MapFilter;
